import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { Drawer, Form, Image, Input, Spin } from "antd";
import log from "./../../../images/log.png";
import { newCompanyP } from "../../../lib/newCompanyProfile";
import { toast, ToastContainer } from "react-toastify";
import { getCompanyP } from "../../../lib/getCompanyProfile";

const notifyBottomRight = () => {
  toast.success("✔️ Perfil guardado exitosamente.", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const Profile = () => {
  const [profileInfo, setProfileInfo] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [urlInput, setUrlInput] = useState("");
  const [idCurrentUser, setIdCurrentUser] = useState("");
  const [showSpin, setShowSpin] = useState(true);

  useEffect(() => {
    const savedInStorage = JSON.parse(localStorage.getItem("userDetails"));

    if (savedInStorage) {
      if (!savedInStorage.companyProfile) {
        //* hago el intento de buscar en db
        getCompanyP(savedInStorage._id).then((res) => {
          setProfileInfo(res.data);
          setUrlInput(res.data.image);
        });
      }
      setTimeout(() => {
        setShowSpin(false);
      }, 1000);

      setProfileInfo(savedInStorage.companyProfile);
      setIdCurrentUser(savedInStorage._id);
    }
  }, []);

  const [form] = Form.useForm();

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            {showSpin ? (
              <Spin style={{ marginTop: "5%" }} />
            ) : (
              <>
                {Object.keys(profileInfo).length > 0 ? (
                  <>
                    <div className="col-xl-12 col-md-12">
                      <div className="card justify-content-center">
                        <div className="card-body d-flex">
                          <div className="d-block">
                            <img
                              src={profileInfo.image}
                              className="avatar avatar-xxl"
                              alt=""
                            />
                          </div>
                          <div className="w-100 ps-4">
                            <div className="d-flex justify-content-between">
                              <div className="">
                                <h4 className="font-w700">
                                  {" "}
                                  {profileInfo.name}{" "}
                                </h4>
                                <span> {profileInfo.address} </span>
                              </div>
                              <div className="d-flex">
                                <Dropdown.Toggle
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setOpenDrawer(!openDrawer)}
                                  as="div"
                                  className="icon-box icon-box-sm bg-primary-light i-false"
                                >
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M27.3925 4.60647C26.1493 3.36576 24.4647 2.66895 22.7083 2.66895C20.9519 2.66895 19.2673 3.36576 18.0241 4.60647L15.5295 7.10101L4.30461 18.3265C4.10055 18.5303 3.96826 18.7948 3.92767 19.0803L2.67994 27.8109C2.65288 28 2.66679 28.1927 2.72072 28.376C2.77465 28.5593 2.86735 28.7289 2.99252 28.8732C3.11769 29.0176 3.27243 29.1333 3.44624 29.2126C3.62005 29.292 3.80888 29.333 3.99994 29.333C4.06311 29.3331 4.12621 29.3287 4.18874 29.3197L12.9199 28.0726C13.2054 28.0313 13.4698 27.8989 13.6738 27.695L27.3938 13.9762C28.0091 13.361 28.4972 12.6307 28.8302 11.8268C29.1632 11.023 29.3346 10.1614 29.3346 9.29134C29.3346 8.42126 29.1632 7.5597 28.8302 6.75586C28.4972 5.95202 28.0091 5.22166 27.3938 4.60647H27.3925ZM12.1022 25.4958L5.57154 26.4281L6.50487 19.8981L16.4726 9.92954L22.0709 15.5274L12.1022 25.4958ZM25.5066 12.0909L23.9559 13.6421L18.3574 8.04394L19.9094 6.49181C20.6635 5.77219 21.6659 5.3707 22.7083 5.3707C23.7507 5.3707 24.753 5.77219 25.5071 6.49181C26.2494 7.2344 26.6664 8.24138 26.6664 9.29134C26.6664 10.3413 26.2494 11.3483 25.5071 12.0909H25.5066Z"
                                      fill="#A098AE"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                              </div>
                            </div>
                            <div className="d-flex flex-wrap pt-4">
                              <div className="d-flex align-items-center pe-4 mb-2">
                                <div className="pe-2">
                                  <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M20 4.5H4C3.20435 4.5 2.44129 4.81607 1.87868 5.37868C1.31607 5.94129 1 6.70435 1 7.5V17.5C1 18.2956 1.31607 19.0587 1.87868 19.6213C2.44129 20.1839 3.20435 20.5 4 20.5H20C20.7956 20.5 21.5587 20.1839 22.1213 19.6213C22.6839 19.0587 23 18.2956 23 17.5V7.5C23 6.70435 22.6839 5.94129 22.1213 5.37868C21.5587 4.81607 20.7956 4.5 20 4.5ZM21 17.25L16.1 12.85L21 9.42V17.25ZM3 9.42L7.9 12.85L3 17.25V9.42ZM9.58 14.03L11.43 15.32C11.5974 15.4361 11.7963 15.4984 12 15.4984C12.2037 15.4984 12.4026 15.4361 12.57 15.32L14.42 14.03L19.42 18.5H4.6L9.58 14.03ZM4 6.5H20C20.1857 6.50149 20.3673 6.55467 20.5245 6.65358C20.6817 6.75249 20.8083 6.89322 20.89 7.06L12 13.28L3.11 7.06C3.19171 6.89322 3.31826 6.75249 3.47545 6.65358C3.63265 6.55467 3.81428 6.50149 4 6.5Z"
                                      fill="#F79F19"
                                    />
                                  </svg>
                                </div>
                                <h5 className="font-w400 mb-0">
                                  {profileInfo.email}
                                </h5>
                              </div>
                              <div className="d-flex align-items-center pe-4 mb-2">
                                <div className="pe-2">
                                  <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.4401 13.5004C19.2201 13.5004 18.9901 13.4304 18.7701 13.3804C18.3246 13.2822 17.8868 13.1518 17.4601 12.9904C16.9962 12.8216 16.4862 12.8304 16.0284 13.015C15.5706 13.1996 15.1972 13.547 14.9801 13.9904L14.7601 14.4404C13.7861 13.8985 12.8911 13.2256 12.1001 12.4404C11.3149 11.6494 10.6419 10.7544 10.1001 9.78036L10.5201 9.50036C10.9635 9.28327 11.3109 8.90989 11.4955 8.45205C11.6801 7.99421 11.6889 7.48427 11.5201 7.02036C11.3613 6.59278 11.231 6.15515 11.1301 5.71036C11.0801 5.49036 11.0401 5.26036 11.0101 5.03036C10.8887 4.32598 10.5197 3.6881 9.96972 3.2316C9.41972 2.77509 8.7248 2.52997 8.0101 2.54036H5.0101C4.57913 2.53631 4.15235 2.62517 3.75881 2.80089C3.36527 2.9766 3.01421 3.23505 2.72953 3.55864C2.44485 3.88222 2.23324 4.26335 2.10909 4.67607C1.98494 5.08879 1.95118 5.52342 2.0101 5.95036C2.54284 10.1397 4.45613 14.0322 7.44775 17.013C10.4394 19.9938 14.3388 21.8929 18.5301 22.4104H18.9101C19.6475 22.4114 20.3595 22.1409 20.9101 21.6504C21.2265 21.3674 21.4792 21.0205 21.6516 20.6327C21.8239 20.2448 21.9121 19.8248 21.9101 19.4004V16.4004C21.8979 15.7057 21.6449 15.0369 21.1944 14.508C20.744 13.9791 20.1239 13.623 19.4401 13.5004ZM19.9401 19.5004C19.9399 19.6423 19.9095 19.7827 19.8509 19.912C19.7923 20.0413 19.7068 20.1566 19.6001 20.2504C19.4884 20.3468 19.3577 20.4189 19.2165 20.462C19.0753 20.505 18.9267 20.5181 18.7801 20.5004C15.035 20.0202 11.5563 18.3068 8.89282 15.6306C6.2293 12.9545 4.53251 9.46769 4.0701 5.72036C4.05419 5.57387 4.06813 5.42569 4.1111 5.28475C4.15407 5.14381 4.22517 5.01304 4.3201 4.90036C4.41381 4.79369 4.52916 4.7082 4.65848 4.64957C4.7878 4.59095 4.92812 4.56054 5.0701 4.56036H8.0701C8.30265 4.55518 8.52972 4.63124 8.71224 4.77543C8.89476 4.91962 9.02131 5.12293 9.0701 5.35036C9.1101 5.62369 9.1601 5.89369 9.2201 6.16036C9.33562 6.6875 9.48936 7.20554 9.6801 7.71036L8.2801 8.36036C8.1604 8.41528 8.05272 8.4933 7.96326 8.58995C7.87379 8.6866 7.8043 8.79997 7.75877 8.92355C7.71324 9.04713 7.69257 9.17849 7.69795 9.31008C7.70332 9.44167 7.73464 9.5709 7.7901 9.69036C9.2293 12.7731 11.7073 15.2512 14.7901 16.6904C15.0336 16.7904 15.3066 16.7904 15.5501 16.6904C15.6748 16.6458 15.7894 16.5768 15.8873 16.4875C15.9851 16.3983 16.0643 16.2905 16.1201 16.1704L16.7401 14.7704C17.2571 14.9552 17.7847 15.1088 18.3201 15.2304C18.5868 15.2904 18.8568 15.3404 19.1301 15.3804C19.3575 15.4291 19.5608 15.5557 19.705 15.7382C19.8492 15.9207 19.9253 16.1478 19.9201 16.3804L19.9401 19.5004Z"
                                      fill="#FF5B5B"
                                    />
                                  </svg>
                                </div>
                                <h5 className="font-w400 mb-0">
                                  {profileInfo.phoneNumber}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="card bubles" style={{ height: "300px" }}>
                      <div id="cardCargaEmpleado" className="card-body">
                        <div className="buy-coin  bubles-down">
                          <div>
                            <h3 className="cargaEMpleados">
                              Necesitamos más información sobre su empresa
                            </h3>

                            <Link
                              to={"#"}
                              className="btn btn-primary"
                              onClick={() => setOpenDrawer(true)}
                            >
                              Completar mi perfil
                            </Link>
                          </div>
                          <div className="coin-img">
                            <img src={log} className="img-fluid" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <Drawer
        style={{
          backgroundColor: "#362465",
          borderTopLeftRadius: "15px",
          borderBottomLeftRadius: "15px",
        }}
        destroyOnClose
        width={500}
        title={<label style={{ color: "white" }}>Mi perfil</label>}
        placement={"right"}
        onClose={() => {
          // setSelectedEmployee();
          // form.resetFields();
          setOpenDrawer(false);
        }}
        closable={false}
        open={openDrawer}
        key={"right"}
      >
        <Form
          preserve={false}
          size="small"
          name="employee"
          layout="vertical"
          form={form}
          onFinish={async (v) => {
            //* Guardar perfil
            newCompanyP({ idUser: idCurrentUser, ...v.company }).then((res) => {
              const { data } = res;
              if (data.status) {
                notifyBottomRight();
                getCompanyP(idCurrentUser).then((res) => {
                  setProfileInfo(res.data);
                  setOpenDrawer(false);
                });
              }
            });
          }}
        >
          <Form.Item
            style={{ color: "white" }}
            name={["company", "name"]}
            initialValue={profileInfo && profileInfo.name}
            label={<label style={{ color: "white" }}>Razón social</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{ color: "white" }}
            name={["company", "email"]}
            initialValue={profileInfo && profileInfo.email}
            label={<label style={{ color: "white" }}>Email</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["company", "phoneNumber"]}
            initialValue={profileInfo && profileInfo.phoneNumber}
            label={<label style={{ color: "white" }}>Teléfono</label>}
            rules={[
              {
                required: true,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>

          <Form.Item
            style={{ color: "white" }}
            name={["company", "address"]}
            initialValue={profileInfo && profileInfo.address}
            label={<label style={{ color: "white" }}>Dirección</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          {/* 
          <Form.Item
            style={{ color: "white" }}
            name={["company", "image"]}
            initialValue={profileInfo && profileInfo.image}
            label={<label style={{ color: "white" }}>Imagen (URL)</label>}
            rules={[
              {
                pattern: new RegExp(
                  /^(https?:\/\/)?[a-z0-9\-\.]+\.[a-z]{2,6}\.?([a-z]{2,6})?(\/.*)?$/i
                ),
              },
            ]}
          >
            {(profileInfo && profileInfo.image) || urlInput ? (
              <>
                <Image
                  width={100}
                  height={100}
                  preview={false}
                  src={urlInput}
                  fallback="data:image/png;base64,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"
                />
                <Link
                  to={"#"}
                  className="btn btn-danger shadow btn-xs sharp"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    setUrlInput("");
                    form.resetFields(["company", "image"]);
                  }}
                >
                  <i className="fa fa-trash"></i>
                </Link>
              </>
            ) : (
              <Input
                onBlur={(v) => {
                  const regex =
                    /^(https?:\/\/)?[a-z0-9\-\.]+\.[a-z]{2,6}\.?([a-z]{2,6})?(\/.*)?$/i;

                  if (regex.test(v.target.value)) {
                    setUrlInput(v.target.value);
                  }
                }}
              />
            )}
          </Form.Item> */}

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              marginTop: "15%",
            }}
          >
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                htmlType="submit"
                className="btn btn-primary"
              >
                Guardar
              </button>
            </Form.Item>
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenDrawer(false);
                }}
              >
                Cancelar
              </button>
            </Form.Item>
          </div>
        </Form>
      </Drawer>
      <ToastContainer />
    </>
  );
};
export default Profile;
